var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent36(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#b88d69",
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    opacity: 1,
    fill: "#ecc6a4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecc6a4",
    opacity: 1,
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.104+117.651C632.104+117.651+620.205+109.126+631.275+90.3166C646.004+65.2912+697.502+44.1502+734.123+100.228C742.989+113.806+751.297+131.34+765.446+164.988C775.422+188.712+783.395+216.818+789.998+252.264C796.601+287.71+802.985+477.477+786.437+478.337C769.889+479.197+773.378+373.61+738.844+268.332C728.496+236.784+731.84+237.323+706.199+202.19C676.777+161.875+632.104+117.651+632.104+117.651Z",
    fill: "#383738",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#b88d69",
    d: "M616.068+112.501L616.068+112.501C621.015+108.481+628.58+109.044+632.965+113.759L696.948+182.563C701.333+187.278+700.877+194.36+695.93+198.38L695.93+198.38C690.983+202.401+683.417+201.838+679.033+197.122L615.05+128.319C610.665+123.603+611.121+116.522+616.068+112.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.21+89.9298C521.057+89.4343+538.719+91.5648+538.719+91.5648C675.868+95.6521+728.663+231.024+691.824+367.141C691.824+367.141+674.444+168.407+521.262+165.137C368.081+161.867+335.922+360.273+335.922+360.273C301.58+220.41+365.248+94.0172+504.21+89.9298Z",
    fill: "#383738",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent36);
export default __webpack_public_path__ + "static/media/Student 36.ff48809a9d5863b1416ad7a9560d3d3d.svg";
export { ForwardRef as ReactComponent };